import React, { useEffect, useState } from "react";
import { Sprint } from "../types/Sprint";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import "../styles/Form.css";

interface Props {
  onSave: (sprint: Sprint) => void;
  initialData?: Sprint | null;
  clearAfterSubmit: () => void;
}

const initialState: Sprint = {
  id: 0,
  sprint: "",
  projectId: 0,
  startDate: "",
  endDate: "",
  remarks: "",
  status: "new",
};

const SprintForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
}) => {
  const [form, setForm] = useState<Sprint>(initialState);

  const projects = useSelector((state: StoreState) => state.project);

  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        projectId: Number(initialData.projectId),
      });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "projectId" ? parseInt(value) : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(form);
    setForm(initialState);
    clearAfterSubmit();
  };

  const handleClear = () => {
    setForm(initialState);
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="sprint">
              <Form.Label>
                Sprint <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="sprint"
                value={form.sprint}
                onChange={handleChange}
                placeholder="Sprint Name"
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="projectId">
              <Form.Label>Project</Form.Label>
              <Form.Select
                name="projectId"
                value={form.projectId ? form.projectId.toString() : ""}
                onChange={handleChange}
                required
                style={{
                  borderColor: "rgb(215, 210, 210)",
                }}
              >
                <option value="">Select a project</option>
                {projects.map((project) => (
                  <option key={project.id} value={project.id}>
                    {project.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="start date">
              <Form.Label>
                startDate <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="startDate"
                value={form.startDate}
                onChange={handleChange}
                placeholder="Start Date"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="end date">
              <Form.Label>
                endDate<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="endDate"
                value={form.endDate}
                onChange={handleChange}
                placeholder="End Date"
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="remarks">
              <Form.Label>
                remarks<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="remarks"
                value={form.remarks}
                onChange={handleChange}
                placeholder="Remarks"
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Select
                name="status"
                value={form.status}
                onChange={handleChange}
                style={{
                  borderColor: "rgb(215, 210, 210)",
                }}
              >
                <option value="new">New</option>
                <option value="processing">Processing</option>
                <option value="completed">Completed</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col md={12}>
            <div className="form-buttons">
              <Button type="submit" className="btn-save">
                {initialData?.id ? "Update" : "Save"}
              </Button>
              <Button type="button" className="btn-clear" onClick={handleClear}>
                Clear All
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SprintForm;
